import { ArrowRight, Eye } from 'lucide-react';
import { routeToIntake } from '../lib/intakeRouting';

// Hero implements the ratified storyboard_s1_hero_v2 logic: camera-lens eye motif,
// dark cinematic base, MACELLUM gradient wordmark. The brand mark is the ratified
// asset itself (never regenerated). Live CTAs route to the two-offer MVP intake.
export function Hero() {
  return (
    <section className="relative w-full overflow-hidden bg-obsidian text-chalk">
      <div className="mx-auto grid w-full max-w-7xl gap-12 px-4 py-20 sm:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:px-8 lg:py-28">
        {/* Ratified eye / wordmark brand asset */}
        <div className="relative">
          <img
            src="/assets/storyboard_s1_hero_v2.webp"
            alt="Macellum — a camera-lens eye above the gradient MACELLUM wordmark with the line: get your business seen."
            className="w-full select-none rounded-sm"
            loading="eager"
          />
        </div>

        {/* Proof-to-presence promise + live CTAs */}
        <div className="max-w-xl">
          <p className="inline-flex items-center gap-2 border border-cyan/30 bg-cyan/5 px-3 py-1 text-xs font-black uppercase tracking-wide text-cyan">
            <Eye className="size-4" aria-hidden="true" />
            Proof-to-presence
          </p>
          <h1 className="mt-6 text-4xl font-black leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
            Turn business proof into{' '}
            <span className="text-wordmark">visible, citable, sales-ready</span> market presence.
          </h1>
          <p className="mt-6 text-lg leading-8 text-ash">
            You have done real work. Macellum turns that proof into a website, social and local
            updates, and AI-readable context — from a single message. Send proof once; let everyone
            see it.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => routeToIntake({ intent: 'm2m', productHint: 'm2m_t1' })}
              className="inline-flex h-12 items-center justify-center gap-2 bg-cyan px-6 text-sm font-black uppercase tracking-wide text-obsidian transition hover:bg-violet hover:text-chalk"
            >
              Turn proof into presence
              <ArrowRight className="size-5" aria-hidden="true" />
            </button>
            <button
              type="button"
              onClick={() => routeToIntake({ intent: 'aeo', productHint: 'aeo_t1' })}
              className="inline-flex h-12 items-center justify-center gap-2 border border-violet/60 px-6 text-sm font-black uppercase tracking-wide text-chalk transition hover:border-violet hover:bg-violet/10"
            >
              Repair my AI visibility
            </button>
          </div>

          <p className="mt-6 text-sm leading-6 text-ash/80">
            Message-to-Market by Macellum and AEO Visibility Repair. Manual-first, draft-only — nothing
            is published without your approval.
          </p>
        </div>
      </div>

      {/* Subtle cinematic gradient floor, full-saturation accents only */}
      <div
        className="pointer-events-none absolute inset-x-0 bottom-0 h-1 opacity-90"
        style={{ background: 'linear-gradient(to right, #18D6FF 0%, #6E4DFF 50%, #D4A017 100%)' }}
      />
    </section>
  );
}
